'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hierarchiseDimensionWithAdvancedHierarchy = exports.refinePartialHierarchy = undefined;
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var uniq = R.pipe(R.reduce(function (_ref, id) {
  var ids = _ref.ids,
    list = _ref.list;
  if (R.has(id, list)) {
    return {
      ids: ids,
      list: list
    };
  }
  return {
    ids: R.append(id, ids),
    list: R.assoc(id, id, list)
  };
}, {
  ids: [],
  list: {}
}), R.prop('ids'));
var refinePartialHierarchy = exports.refinePartialHierarchy = function refinePartialHierarchy(hier, indexed) {
  var _R$pipe = R.pipe(R.keys, R.reduce(function (_ref2, key) {
      var intact = _ref2.intact,
        broken = _ref2.broken;
      var ids = R.filter(function (id) {
        return R.has(id, indexed);
      }, hier[key]);
      if (key === '#ROOT') {
        return {
          broken: broken,
          intact: R.assoc(key, ids, intact)
        };
      }
      var splitKey = R.split('.', key);
      var filtered = R.takeLastWhile(function (id) {
        return R.has(id, indexed);
      }, splitKey);
      if (R.length(filtered) === R.length(splitKey)) {
        return {
          broken: broken,
          intact: R.assoc(key, ids, intact)
        };
      }
      var refinedKey = R.isEmpty(filtered) ? '#ROOT' : R.join('.', filtered);
      return {
        intact: intact,
        broken: R.over(R.lensProp(refinedKey), R.ifElse(R.isNil, R.always([ids]), R.append(ids)))(broken)
      };
    }, {
      intact: {},
      broken: {}
    }))(hier),
    intact = _R$pipe.intact,
    broken = _R$pipe.broken;
  var intactIds = R.pipe(R.values, R.unnest)(intact);
  var refinedBroken = R.pipe(R.omit(intactIds), R.over(R.lensProp('#ROOT'), R.pipe(function (i) {
    return R.isNil(i) ? [] : i;
  }, R.unnest, R.reject(R.flip(R.includes)(intactIds)))), R.map(R.pipe(R.unnest, uniq)))(broken);
  return (0, _extends3.default)({}, refinedBroken, intact, {
    '#ROOT': R.concat(refinedBroken['#ROOT'], intact['#ROOT'])
  });
};
var hierarchiseDimensionWithAdvancedHierarchy = exports.hierarchiseDimensionWithAdvancedHierarchy = function hierarchiseDimensionWithAdvancedHierarchy(dimension, _hierarchy) {
  var indexed = R.indexBy(R.prop('id'), dimension.values);
  var hierarchy = refinePartialHierarchy(_hierarchy, indexed);
  var rest = R.pipe(R.values, R.unnest, R.flip(R.omit)(indexed), R.values)(hierarchy);
  var index = R.length(rest) - 1;
  var getChildren = function getChildren(_ref3) {
    var parentsIndexes = _ref3.parentsIndexes,
      parentId = _ref3.parentId;
    var childrenIds = R.propOr([], parentId, hierarchy);
    var children = R.reduce(function (acc, childId) {
      if (!R.has(childId, indexed)) {
        return acc;
      }
      index = index + 1;
      var child = (0, _extends3.default)({}, R.prop(childId, indexed), {
        __indexPosition: index,
        parents: parentsIndexes,
        parent: R.isEmpty(parentsIndexes) ? undefined : R.pipe(R.split('.'), R.last)(parentId)
      });
      var descendants = getChildren({
        parentsIndexes: R.append(index, parentsIndexes),
        parentId: R.isEmpty(parentsIndexes) ? child.id : parentId + '.' + child.id
      });
      return R.append(R.prepend(child, descendants), acc);
    }, [], childrenIds);
    return children;
  };
  return R.set(R.lensProp('values'), R.pipe(getChildren, R.flatten, function (values) {
    if (R.isEmpty(rest)) {
      return values;
    }
    var sortedRest = R.pipe(R.sortBy(R.prop('__indexPosition')), R.addIndex(R.map)(function (val, ind) {
      return (0, _extends3.default)({}, val, {
        __indexPosition: ind,
        parent: undefined,
        parents: []
      });
    }))(rest);
    return R.concat(sortedRest, values);
  })({
    parentsIndexes: [],
    parentId: '#ROOT'
  }))(dimension);
};